import { render, staticRenderFns } from "./events_business.vue?vue&type=template&id=036b9645&"
import script from "./events_business.vue?vue&type=script&lang=js&"
export * from "./events_business.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports